export const getLocale = (search = '') => {
  return new URLSearchParams(search).get('locale');
};

export const buildPopoutURL = ({
  origin,
  authToken,
  widgetId,
  locale,
}) => {
  const popoutUrl = new URL('/widget', origin);

  // TODO: This shouldn't be necessary but need to run the create session call within the popup
  popoutUrl.searchParams.append('auth_token', authToken);
  popoutUrl.searchParams.append('widget_id', widgetId);
  popoutUrl.searchParams.append('locale', locale);

  return popoutUrl.toString();
};
